export const isUserScroll = ({threshold}, event) => {
    const elOuter = event.target;

    const widthInner = elOuter.scrollWidth;
    const widthOuter = elOuter.offsetWidth;
    
    const scrollLeft = elOuter.scrollLeft;

    const widthInvisible = widthInner - widthOuter;

    const scroll = widthInvisible - scrollLeft;
  
    return scroll > threshold;
  };
  